import { AreaNotification, Breakpoint } from "@relode/core";
import * as React from "react";

import {
    ClientPublicCandidateProvider,
    useClientPublicCandidateContext,
} from "../_infra/clientPublicCandidateProvider";
import {
    ClientPublicCandidateDetailsDesktop,
} from "./clientPublicCandidateDetailsDesktop";
import {
    ClientPublicCandidateDetailsMobile,
} from "./clientPublicCandidateDetailsMobile";

export const ClientPublicCandidateDetailsContainer = () => (
    <ClientPublicCandidateProvider>
        <ClientPublicCandidateDetailsContainerWrapper />
    </ClientPublicCandidateProvider>
);

const ClientPublicCandidateDetailsContainerWrapper = () => {
    const {
        state: {
            data: { candidate },
        },
    } = useClientPublicCandidateContext();

    return (
        <>
            <AreaNotification areaName="loadCandidate" />
            {candidate ? (
                <>
                    <Breakpoint mobile>
                        <ClientPublicCandidateDetailsMobile />
                    </Breakpoint>
                    <Breakpoint desktop>
                        <ClientPublicCandidateDetailsDesktop />
                    </Breakpoint>
                </>
            ) : null}
        </>
    );
};
